import "./styles/app.scss";
import { Provider } from "react-redux";
import Hero from "./components/Hero.js";
import ModifyIntake from "./components/ModifyIntake";
import Intake from "./components/Intake";
import IntakeHistory from "./components/IntakeHistory";
import WeeklyNutrition from "./components/WeeklyNutrition";
import Footer from "./components/Footer";
import store from "./redux/store";

const App = () => {
  return (
    <Provider store={store}>
      <Hero />
      <ModifyIntake />
      <Intake />
      <IntakeHistory />
      <WeeklyNutrition />
      <Footer />
    </Provider>
  );
};

export default App;
